/** Spanish unit-rate vocabulary and template (ADR 0051 part 3). */
export const ratePairs: Array<{ of: string; per: string; perPlural: string }> = [
    { of: 'millas', per: 'hora', perPlural: 'horas' },
    { of: 'palabras', per: 'minuto', perPlural: 'minutos' },
    { of: 'dólares', per: 'artículo', perPlural: 'artículos' },
    { of: 'páginas', per: 'día', perPlural: 'días' },
    { of: 'litros', per: 'minuto', perPlural: 'minutos' },
    { of: 'puntos', per: 'partido', perPlural: 'partidos' },
];

export const ratioPrompts = {
    unitRate: (total: number, of: string, units: number, perPlural: string, per: string) =>
        // The unit is not repeated after the blank the way English repeats it:
        // ADR 0051 §7 part 3's Language sweep found the repetition ran Unit Rate
        // onto an extra page at 12 per page with answer keys. "120 palabras en
        // 4 minutos = ______ por minuto" carries the unit from the left-hand side.
        `${total} ${of} en ${units} ${perPlural} = ______ por ${per}`,
    /** ADR 0104 §2: the three table questions and the two answers of the first. */
    proportionalYesNo: () =>
        `¿Es y proporcional a x? Si lo es, da la constante de proporcionalidad.`,
    proportionalConstant: () =>
        `Halla la constante de proporcionalidad y escribe una ecuación para y.`,
    proportionalFill: () => `y es proporcional a x. Completa la tabla.`,
    proportionalYes: (constant: number) => `Sí, k = ${constant}`,
    proportionalNo: () => `No`,
    /** ADR 0105 §2: the graph question that reads past the edge of the grid. */
    proportionalBeyond: (x: number) => `Usa la gráfica para hallar y cuando x = ${x}.`,
};
